module.exports = __webpack_public_path__ + "static/contribute_lr-80591672b309ebef539deb16df4e2e9a.webp";